import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoSectionCarousel from 'eco-design/sections/eco-section-carousel';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Swiper as SwiperType } from 'swiper/types';
import styles from './index.module.scss';

export default function SectionA5() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.SectionCarousel');
    const [swiperDom, setSwiperDom] = useState<SwiperType>();

    const cardList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402209165/ksp_01.png',
            title: t('item1_title'),
            desc: '',
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402210718/ksp_02.png',
            title: t('item2_title'),
            desc: '',
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402210373/ksp_03.png',
            title: t('item3_title'),
            desc: '',
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402210536/ksp_04.png',
            title: t('item4_title'),
            desc: '',
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402210160/ksp_05.png',
            title: t('item5_title'),
            desc: '',
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402209955/ksp_06.png',
            title: t('item6_title'),
            desc: '',
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402209341/ksp_07.png',
            title: t('item7_title'),
            desc: '',
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402209765/ksp_08.png',
            title: t('item8_title'),
            desc: '',
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750402209551/ksp_09.png',
            title: t('item9_title'),
            desc: '',
            icon: '',
        },
    ];

    return (
        <div className={`page-sectionCarousel ${styles.SectionCarousel}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSectionCarousel
                autoplay={{
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                    animationNavigationRight: true,
                    viewport: {
                        open: true,
                    },
                }}
                // swiperAutoPlay={true}
                items={cardList}
                pagination
                getSwiperDom={(data: any) => setSwiperDom(data)}
            />
            <EcoSpace />
        </div>
    );
}
